export default __webpack_public_path__ + "static/media/781.8e8020bd.png";